<script>
  import WishlistTrigger from "./WishlistTrigger.svelte";
  import FeaturedProductCardInformation from "./FeaturedProductCardInformation.svelte";
  import ProductCardColourSwatches from "./ProductCardColourSwatches.svelte";
  import { loop_guard } from "svelte/internal";

  export let product;
  export let video;
  export let shopify_video;
  export let image;
  export let classes;
</script>


  <div class="col-span-2 lg:col-span-4 {classes}">
    <div class="overflow-y-hidden overflow-x-auto xl:overflow-hidden">
      <div class="w-[150%] xl:w-full my-4 flex">
        <div class="contents space-x-1 xl:space-x-2">
          <div class="w-[50%] xl:w-1/2 relative flex flex-col">
            <div class="bg-product-image-blend aspect-w-1 aspect-h-1 relative">
              <a href="{product.url}" class="block w-full h-full z-10 mix-blend-multiply">
                <img
                  src="{product.sizedProgressiveImage(1000)}"
                  alt="{product.title}"
                  class="mix-blend-multiply w-auto w-full mx-auto object-contain featured-product-card__image"
                  loading="lazy"
                >
              </a>

              {#if product.optionNames.includes('Colour')}
                <ProductCardColourSwatches product="{product}" reference="FeaturedProductCard" />
              {/if}
            </div>

            <span class="absolute right-1.5 top-1 z-10 flex justify-end w-full">
              <WishlistTrigger product="{product}" productVariantId="{product.variants[0].id}" productImageURL="{product.sizedProgressiveImage(384)}" />
            </span>

            <FeaturedProductCardInformation
              product="{product}"
              parentClasses="{'hidden xl:flex flex-col justify-end absolute w-full h-full px-1/24 pb-2 top-0 left-0 mt-0'}"
            />
          </div>
          <div class="w-[50%] xl:w-1/2">
            <div class="aspect-w-1 aspect-h-1">
              {#if shopify_video }
                <video
                  class="w-full"
                  src="{shopify_video}"
                  title="Shopify video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  loop
                  muted
                  playsinline 
                  autoplay
                ></video>
              {:else if video}
                <iframe
                  class="w-full"
                  src="https://www.youtube.com/embed/{video}?color=white&controls=0&rel=0&autoplay=1&loop=1&mute=1&showinfo=0&playlist={video}"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              {:else if image}
                <img src="{image}" alt="{product.title} featured image" class="object-cover" />
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>

    <FeaturedProductCardInformation
      product="{product}"
      parentClasses="{'flex xl:hidden flex-col justify-end w-full px-1/24'}"
    />
  </div>
